export { default as LandingPage } from './landing-page';
export { default as LandingPage2026 } from './landing-page-2026';
